export const MAP_DEFS = {
  village: {
    mapId: "village",
    sceneKey: "VillageScene",
    mapJsonKey: "village-map-data",
    mapJsonPath: "assets/maps/village.tmj",
    backgrounds: {
      bg1: { key: "bg1", path: "assets/backgrounds/village/background_01.png" },
      bg2: { key: "bg2", path: "assets/backgrounds/village/background_02.png" },
    },
    isSafeZone: true,
    enableRandomTestItems: true,
  },
  map_combat_01: {
    mapId: "map_combat_01",
    sceneKey: "MapCombat01Scene",
    mapJsonKey: "map-combat-01-map-data",
    // Placeholder until a new Tiled map is exported.
    mapJsonPath: "assets/maps/village.tmj",
    backgrounds: {
      bg1: { key: "bg1", path: "assets/backgrounds/village/background_01.png" },
      bg2: { key: "bg2", path: "assets/backgrounds/village/background_02.png" },
    },
    isSafeZone: false,
    enableRandomTestItems: false,
  },
};
